import React from 'react';
import { Box, Button, Container, Typography, Grid, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 8 }}>
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            component="h1"
            sx={{ 
              fontWeight: 'bold', 
              mb: 2,
              color: '#e4e4e4'
            }}
          >
            Welcome to GrooveGate
          </Typography>
          <Typography variant="h5" color="text.secondary" paragraph>
            Share your music and get valuable feedback from other artists
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/register')}
            sx={{ mt: 2 }}
          >
            Get Started
          </Button>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3, height: '100%' }}>
              <Typography variant="h5" gutterBottom>
                Share Your Music
              </Typography>
              <Typography>
                Upload your tracks and share them privately with other artists to get feedback before release.
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3, height: '100%' }}>
              <Typography variant="h5" gutterBottom>
                Give & Receive Feedback
              </Typography>
              <Typography>
                Connect with other musicians, exchange valuable feedback, and improve your music together.
              </Typography>
            </Paper>
          </Grid>
          
          <Grid item xs={12} md={4}>
            <Paper sx={{ p: 3, height: '100%' }}>
              <Typography variant="h5" gutterBottom>
                Track Your Progress
              </Typography>
              <Typography>
                Monitor engagement, manage feedback, and share positive comments on social media.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default HomePage;